<template>
  <rich-text-editor
    v-model="content"
    :input-id="inputId"
    :input-name="inputName"
    variant="minimal"
    :placeholder="computedPlaceholder"
    :enable-image-upload="true"
    :enable-embeds="false"
    :enable-drafts="false"
    upload-url="/posts/images"
  ></rich-text-editor>
</template>

<script>
export default {
  name: 'EditPostContent',

  props: {
    inputId: {
      type: String,
      default: 'post_content'
    },
    inputName: {
      type: String,
      default: 'post[content]'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      content: window.editPostContent || ''
    };
  },

  computed: {
    computedPlaceholder() {
      return this.placeholder || this.$t('Describe your idea');
    }
  },

  mounted() {
    // Trix syncs its linked hidden input asynchronously; force a sync at
    // submit time so a fast Save click can never post stale content.
    this.syncOnSubmit = () => {
      const input = document.getElementById(this.inputId);
      const editor = input && document.querySelector(`trix-editor[input="${this.inputId}"]`);
      if (input && editor && typeof editor.value === "string") {
        input.value = editor.value;
      }
    };
    const form = this.$el.closest("form");
    if (form) form.addEventListener("submit", this.syncOnSubmit);
  },

  beforeDestroy() {
    const form = this.$el && this.$el.closest("form");
    if (form && this.syncOnSubmit) form.removeEventListener("submit", this.syncOnSubmit);
  }
};
</script>
